import React from 'react';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router';
import { LoginPage } from '@/features/auth/components/LoginPage';
import { AuthProvider } from '@/features/auth/contexts/AuthContext';
import { ListTenantsPage } from '@/features/tenants/components/ListTenantsPage';
import { ListProjectsPage } from '@/features/projects/components/ListProjectsPage';
import { ListAdminUsersPage } from '@/features/admin-users/components/ListAdminUsersPage';
import { AdminLayout } from '@/components/layouts/AdminLayout';
import { Toaster } from '@/components/ui/toaster';
import './index.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Toaster />
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route element={<AdminLayout />}>
            <Route path="/" element={<Navigate to="/tenants" />} />
            <Route path="/admin-users" element={<ListAdminUsersPage />} />
            <Route path="/tenants" element={<ListTenantsPage />} />
            <Route path="/tenants/:tenantId/projects" element={<ListProjectsPage />} />
          </Route>
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>
);
